import { IsEnum, IsOptional } from 'class-validator';

import { OrderStatusEnum } from '@onArte/shared/enums/common/orders';
import { ListQuery } from '@onArte/shared/models/common';

export class SalesListQuery extends ListQuery {
  @IsOptional()
  @IsEnum(OrderStatusEnum)
  public status?: OrderStatusEnum;

  constructor(
    limit?: number,
    offset?: number,
    status?: OrderStatusEnum,
  ) {
    super(limit, offset);

    this.status = status;
  }
}
